import React from 'react';
import { Query } from 'react-apollo';
import NoteReadOnly from '../../../components/NoteReadOnly';
import { ErrorScreen, Loading } from '../../../components/utils';
import { noteQuery } from '../../../queries/notes';

const Note: React.FC<{ noteId: string }> = ({ noteId }) => (
  <Query query={noteQuery} variables={{ id: noteId }}>
    {({ data, error, loading }) => {
      if (loading) {
        return <Loading />;
      }
      if (error) {
        return <ErrorScreen error={error.message} />;
      }
      const { note } = data;

      return (
        <div className="flex flex-column fixed absolute--fill">
          <NoteReadOnly note={note} />
        </div>
      );
    }}
  </Query>
);

export default Note;
